import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { DownloadSimple } from "@phosphor-icons/react";
import { formatET } from "../lib/dateUtils";
import { toast } from "sonner";
import { DashboardLayout } from "../components/layout/DashboardLayout";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { getClientNavItems } from "../modules/clientNav";

export default function ReportArchivePage() {
  const { user } = useAuth();
  const [reports, setReports] = useState(null);
  const navItems = getClientNavItems(user?.unlocked_modules);

  useEffect(() => {
    api.get("/client/reports").then(({ data }) => setReports(data));
  }, []);

  const downloadReport = async (report) => {
    try {
      const res = await api.get(`/reports/${report.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `IGC-Report-${report.month_label}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not generate report PDF. Please try again.");
    }
  };

  return (
    <DashboardLayout navItems={navItems} moduleName="Report Archive" moduleBackPath="/client">
      <div data-testid="report-archive-page">
        <h1 className="font-serif text-3xl text-igc-cream tracking-tight mb-2">Report Archive</h1>
        <p className="text-igc-muted text-sm mb-8">Every monthly performance summary approved for your store, available to download anytime.</p>
        {!reports && <p className="text-igc-muted text-sm">Loading...</p>}
        {reports && reports.length === 0 && <p className="text-igc-muted text-sm" data-testid="archive-empty-state">No monthly reports yet.</p>}
        <div className="space-y-3">
          {reports?.map((r, i) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="bg-igc-surface border border-igc-gold/15 p-5 flex items-center justify-between"
              data-testid={`archive-report-row-${r.id}`}
            >
              <div>
                <p className="font-serif text-lg text-igc-cream">{r.month_label} Performance Summary</p>
                <p className="text-igc-muted text-xs">Week ending {r.week_ending} — approved {formatET(r.approved_at, "MMM d, yyyy")}</p>
              </div>
              <button
                data-testid={`archive-download-button-${r.id}`}
                onClick={() => downloadReport(r)}
                className="flex items-center gap-1.5 text-xs text-igc-goldText hover:text-igc-goldHover transition-colors border border-igc-gold/30 px-4 py-2 hover:-translate-y-0.5"
              >
                <DownloadSimple size={14} /> Download PDF
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
